import join from 'lodash/join';
import FEATURES from './features';

export const APP_ENV = process.env.REACT_APP_ENV;
export const [APP, ENV] = APP_ENV.match(/(.+)_(.+)$/).slice(1);
export const API_URL = process.env.REACT_APP_API_URL;
export const EVENT_TOKEN = process.env.REACT_APP_EVENT_TOKEN;
export const CMS_API_URL = process.env.REACT_APP_CMS_API_URL;
export const RONGCLOUD_APP_KEY = process.env.REACT_APP_RONGCLOUD_APP_KEY;
export const RONGCLOUD_CHATROOM_PREFIX = process.env.REACT_APP_RONGCLOUD_CHATROOM_PREFIX;
export const MATOMO_SITE_ID = process.env.REACT_APP_MATOMO_SITE_ID;
export const EVENT_START_TIME = process.env.REACT_APP_EVENT_START_TIME;
export const EVENT_END_TIME = process.env.REACT_APP_EVENT_END_TIME;
export const EVENT_NAME = process.env.REACT_APP_EVENT_NAME;
export const EVENT_REGISTER_START_TIME = process.env.REACT_APP_EVENT_REGISTER_START_TIME;
export const EVENT_REGISTER_END_TIME = process.env.REACT_APP_EVENT_REGISTER_END_TIME;
export const EVENT_STAGE_PROGRAMME_REGISTER_END_TIME = process.env.REACT_APP_EVENT_STAGE_PROGRAMME_REGISTER_END_TIME;
export const EVENT_BANNERS = process.env.REACT_APP_EVENT_BANNERS === undefined ? {
  left: [],
  middle: [],
  right: [],
  mobile: [],
} : JSON.parse(process.env.REACT_APP_EVENT_BANNERS);
export const FIRST_VISIBLE_ROUTES = process.env.REACT_APP_FIRST_VISIBLE_ROUTES.split(',');
export const ORGANISER_NAME = process.env.REACT_APP_ORGANISER_NAME;
export const ORGANISER_DOMAIN = process.env.REACT_APP_ORGANISER_DOMAIN;
export const PAGE_NAMES = JSON.parse(process.env.REACT_APP_PAGE_NAMES);
export const WEBINAR_START_TIME = process.env.REACT_APP_WEBINAR_START_TIME;
export const ON_DEMAND_WEBINAR_START_TIME = process.env.REACT_APP_ON_DEMAND_WEBINAR_START_TIME;
export const CUSTOM_ORDER = process.env.REACT_APP_CUSTOM_ORDER ? JSON.parse(process.env.REACT_APP_CUSTOM_ORDER) : {};
export const FILTER_LIST = process.env.REACT_APP_FILTER_LIST ? process.env.REACT_APP_FILTER_LIST.split(',') : [];
export const FILTER_CUSTOM_LABEL = process.env.REACT_APP_FILTER_CUSTOM_LABEL ? JSON.parse(process.env.REACT_APP_FILTER_CUSTOM_LABEL) : {};

const REACT_APP_ACL = process.env.REACT_APP_ACL || 'function acl() { return true; }';
// eslint-disable-next-line no-eval
export const ACL = eval(`${REACT_APP_ACL}; acl`);

export const ENABLED_FEATURES = FEATURES;
(JSON.parse(process.env.REACT_APP_FEATURES || null) || []).forEach((feature) => {
  ENABLED_FEATURES[feature] = true;
});

export const CORPORATE_REGFORM_URL = process.env.REACT_APP_CORPORATE_REGFORM_URL;
export const PUBLIC_REGFORM_URL = process.env.REACT_APP_PUBLIC_REGFORM_URL;

const boothFields = [
  'id',
  'sort',
  'meetup_url',
  'booth_number',
  'translations.vertical_banner.data',
  'website',
  'booth_color',
  'booth_bg_color',
  'logo.data',
  'translations.language',
  'translations.name',
  'translations.description',
  'translations.extra_fields',
  'tags',
  'country',
  'contacts',
  'files',
  'files.*.*',
];
if (APP_ENV === 'hkstp608_production') {
  boothFields.push('hide_chatroom');
}
export const FETCH_EXHIBITORS_URL = `${CMS_API_URL}/items/booth?fields=${join(boothFields, ',')}`;

const webinarFields = APP_ENV.startsWith('hkstp608')
  ? ['id', 'kind', 'start_time', 'end_time', 'webinar_day.id', 'webinar_day.name', 'webinar_day.date', 'translations.*',
    'speakers.*.*']
  : [
    'id', 'kind', 'start_time', 'end_time', 'webinar_day.id', 'webinar_day.name', 'webinar_day.date', 'translations.*',
    'speakers.webinar_speaker.id', 'speakers.webinar_speaker.translations.*', 'speakers.webinar_speaker.profile_picture_url',
    'speakers.webinar_speaker.profile_picture_file.data.full_url',
  ];

export const FETCH_WEBINAR_URL = `${CMS_API_URL}/items/webinar_session?fields=${join(webinarFields, ',')}`;
export const FETCH_EVENT_URL = `${CMS_API_URL}/items/event`;

export default {
  APP_ENV,
  API_URL,
  EVENT_TOKEN,
  CMS_API_URL,
  FETCH_EXHIBITORS_URL,
  RONGCLOUD_APP_KEY,
  RONGCLOUD_CHATROOM_PREFIX,
  MATOMO_SITE_ID,
  ENABLED_FEATURES,
  ACL,
  EVENT_NAME,
  PAGE_NAMES,
  WEBINAR_START_TIME,
  ON_DEMAND_WEBINAR_START_TIME,
  CUSTOM_ORDER,
  FILTER_LIST,
  FILTER_CUSTOM_LABEL,
};
